<template>
  <el-table-column
    prop="title"
    sortable="custom"
    label="Megnevezés"
    show-overflow-tooltip
    min-width="300"
    fixed
  >
    <template slot-scope="scope">
      <span
        v-if="scope.row.task_items && scope.row.task_items.length"
      >
        {{ scope.row.title }}
        <el-tag
          size="small"
          style="margin-left: 5px;"
        >
          {{ scope.row.task_items.length }} alfeladat
        </el-tag>
      </span>
      <span v-else>
        <el-link
          @click="$router.replace('/representative-processes/tasks/view/' + scope.row.id)"
          type="primary"
          style="display: inline;"
        >
          {{ scope.row.title }}
        </el-link>
      </span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'title',
  };
</script>
